module.exports = __webpack_public_path__ + "static/media/email_login.ca980a30.svg";